<ng-container *transloco="let t">
  <div class="admin-card">
    <app-results-table [results]="results" [isAdmin]="true" [categories]="categories" [genders]="genders"
                       [languages]="languages" [currentEventItem]="eventItem" [race]="race"
                       (filterChange)="handleFilterChange($event)" [showDateOfBirthInTable]="true">
      <div slot="resultsTableAdminTrailingWidgets">
        <app-admin-actions-header (onExportToXls)="exportCompetitorResultsList('xlsx')" (onExportToPdf)="exportCompetitorResultsList('pdf')">
          <div slot="leadingWidgets">
          </div>
          <div slot="trailingWidgets">
            <app-panel [hasDropdown]="true" [disabled]="false" #importPanel (onClose)="initImportParams()">
              <div class="dropdown-panel">
                <div class="pe-2">
                  <app-rounded-button [label]="t('race.management.results.import')"
                                      [btnClass]="'rounded-button--button-black-solid'"
                                      (onClick)="importResultList()">
                    <i class="bi bi-file-arrow-up pe-2"></i>
                  </app-rounded-button>
                </div>
              </div>
              <div class="dropdown-content p-3">
                <div class="admin-card__title">
                  <div class="d-flex justify-content-between align-items-center">
                  <span class="fw-bold">
                    {{ t("race.management.results.import.panel.title") }}
                  </span>
                  </div>
                </div>
                <div class="pt-3">
                  <div class="pt-4 pb-3">
                <span>
                  {{ t("race.management.results.import.step.descrtiption.2") }}
                </span>
                  </div>
                  <div class="pb-3">
                    <app-drag-and-drop [fileType]="FileType.XLS" (fileChange)="resultsFileAdded($event)"
                                       [selectedFile]="selectedFile"/>
                  </div>
                </div>
                <!--    Action buttons row-->
                <div class="d-flex py-4 align-items-center justify-content-end">
                  <div class="pe-3">
                    <button type="button" class="btn btn-secondary btn-min-height"
                            (click)="onImportPanelCancel()">
                      {{ t("app.common.cancel") }}
                    </button>
                  </div>
                  <div>
                    <button type="button" class="btn btn-primary btn-min-height"
                            (click)="onImportPanelSave()" [disabled]="!selectedFile">
                      {{ t("app.common.save") }}
                    </button>
                  </div>
                </div>
              </div>
            </app-panel>
          </div>
        </app-admin-actions-header>
      </div>
    </app-results-table>
    @if (showFabButton && (results?.length ?? 0) > 0) {
      <div (click)="scrollToTop()" class="scroll-to-top">
        <i class="bi bi-arrow-up"></i>
      </div>
    }
  </div>
</ng-container>

